import { useContext, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import AppShell from 'components/app-shell';
import { AvatarModal } from 'components/avatar-modal';
import { RegulamentoModal } from 'components/regulamento-modal';
import TutorialModal from 'components/tutorial-modal';

import { AuthContext } from '../context/AuthContext';

/**
 * Casca das rotas privadas: menu lateral, área de conteúdo e os modais
 * globais, montados uma vez só.
 *
 * Existe como rota de layout, e não dentro do PrivateRoute, porque várias
 * rotas privadas são filhas de outra rota privada — `/reconhecer` nasce sob
 * `/`, o fluxo MAD sob `/minha-equipe`. Com a casca no PrivateRoute, o
 * `<Outlet />` do pai renderizava a filha já dentro da casca dele, e o app
 * exibia dois menus lado a lado. Os modais globais tinham o mesmo problema,
 * anterior a esta casca: montavam duas vezes nessas rotas.
 *
 * Todos os ciclos passam por esta casca: os endereços antigos (`/v2/*`, `/v3/*`)
 * levam às rotas da nova identidade (CAN-02).
 */
export default function PrivateLayout({ redirectTo = '/login' }: { redirectTo?: string }) {
  const { isAuthenticated, user, userInfo } = useContext(AuthContext);
  const location = useLocation();

  const [tutorialClose, setTutorialClose] = useState(false);

  if (!isAuthenticated) {
    if (location.pathname !== '/login' && location.pathname !== '/') {
      sessionStorage.setItem('return', location.pathname);
    }

    return <Navigate to={redirectTo} />;
  }

  return (
    <>
      <AppShell>
        <Outlet />
      </AppShell>

      {user?.extra?.id && (tutorialClose || userInfo?.is_manager || user?.extra?.tutorial) && <RegulamentoModal />}
      <AvatarModal />
      {user?.extra?.id && <TutorialModal onClose={() => setTutorialClose(true)} />}
    </>
  );
}
